import { useEffect } from "react";
import { useAccordionStore } from "src/storage";
import { Formik, FormikDraftCAI } from "src/types";
import { useBoolean } from "src/utils";

type AnyErrors = Record<string, unknown> | unknown[] | unknown;

const getFirstErrorPath = (
  value: AnyErrors,
  path: string[] = [],
): string | undefined => {
  if (value == null || typeof value !== "object") {
    return path.length ? path.join(".") : undefined;
  }

  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const child = value[i];
      if (child === undefined || child === null) continue;

      const result = getFirstErrorPath(child, [...path, String(i)]);
      if (result) return result;
    }
    return undefined;
  }

  for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
    const result = getFirstErrorPath(child, [...path, key]);
    if (result) return result;
  }

  return undefined;
};

export const useScrollToError = ({ errors }: Formik<FormikDraftCAI>) => {
  const [toCheck, startCheck, stopCheck] = useBoolean();
  const expandSectionForField = useAccordionStore(
    (state) => state.expandSectionForField,
  );

  useEffect(() => {
    if (toCheck) {
      stopCheck();

      const errKey = getFirstErrorPath(errors);

      if (errKey) {
        expandSectionForField(errKey);

        setTimeout(() => {
          document?.getElementById(`input-${errKey}`)?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 300);
      }
    }
  }, [errors, toCheck, stopCheck]);

  const triggerFormikCheck = startCheck;

  return { triggerFormikCheck };
};
